import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import { withStyles } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import 'nprogress/nprogress.css';

import 'App.css';

import config from 'config';
import styles from 'AppStyles';
import MainComponent from 'components/Main';
import Header from 'components/Header';
import Multinav from './components/MultiNav';
import AdminMessageBanner from 'components/AdminMessageBanner';

class App extends React.Component {
  constructor(props) {
      super(props);
      this.authHandler = this.authHandler.bind(this);
      this.userInfoHandler = this.userInfoHandler.bind(this);
      this.bannerHandler = this.bannerHandler.bind(this);
      this.handleBannerClose = this.handleBannerClose.bind(this);
  }

  state = {
    user: null,
    isAuthenticated: false,
    token: localStorage.getItem('api.tokenKey'),
    bannerOpen: false,
    bannerMessage: '',
  };


  bannerHandler(message, _icon) {
    this.setState({
      bannerOpen: true,
      bannerMessage: message || '',
    });
  }

  handleBannerClose() {
    this.setState({ bannerOpen: false });
  }

  authHandler(result) {

    if(result !== true) {
      //attributes
      localStorage.removeItem('api.tokenKey');
      localStorage.removeItem('user.FirstName');
      localStorage.removeItem('user.LastName');
      localStorage.removeItem('user.Email');
      localStorage.removeItem('user.UserID');
      localStorage.removeItem('user.Division');
      localStorage.removeItem('user.DxpGuid');

      //permissions
      localStorage.removeItem('user.IsAdmin');
      localStorage.removeItem('user.CanView');
      localStorage.removeItem('user.CanSubmit');
    }

    this.setState({
        user: {
          //attributes
          FirstName: localStorage.getItem('user.FirstName'),
          LastName: localStorage.getItem('user.LastName'),
          Email: localStorage.getItem('user.Email'),
          UserID: localStorage.getItem('user.UserID'),
          Division: localStorage.getItem('user.Division'),
          DxpGuid: localStorage.getItem('user.DxpGuid'),

          //permissions
          IsAdmin: localStorage.getItem('user.IsAdmin') === "true",
          CanView: localStorage.getItem('user.CanView') === "true",
          CanSubmit: localStorage.getItem('user.CanSubmit') === "true"
        },
        isAuthenticated: result,
        token: localStorage.getItem('api.tokenKey')
    });
  }

  userInfoHandler(isDealerPrincipal, IsShareofAccountApprover) {
    this.setState({
        user: {
          IsDealerPrincipal: isDealerPrincipal,
          IsShareofAccountApprover: IsShareofAccountApprover,
          ...this.state.user
        }
    });
  }


  getUserAccessLevel() {
    const { user } = this.state;

    if(user) {
      if(user.IsAdmin) {
        return "Admin";
      } else if((user.CanSubmit && user.IsDealerPrincipal) || (user.CanSubmit && user.IsShareofAccountApprover)){
        return "Approver";
      } else if(user.CanSubmit) {
        return "Submitter";
      } else if(user.CanView) {
        return "Viewer";
      }
    }

    return "None";
  }


  renderDevInfo() {
    const accessLevel = this.getUserAccessLevel();

    if(config.debugMode === "true") {
      return (
        <Typography>
          <span style={{backgroundColor: 'red', color:'white'}}> DEBUG MODE </span>
          <p> Access Level: { accessLevel }</p>
        </Typography>
      );
    }
  }


  render() {
    const { classes } = this.props;
    const { isAuthenticated, token, user, bannerOpen, bannerMessage } = this.state;
    const userDisplayName = user ? user.FirstName : null;
    
    return (
      <React.Fragment>
        <Multinav />
        <CssBaseline />
        <Header classes={classes} styles={styles} isAuthenticated={isAuthenticated} userDisplayName={userDisplayName} />
        <AdminMessageBanner
          open={bannerOpen}
          message={bannerMessage}
          onDismiss={this.handleBannerClose}
        />
        { this.renderDevInfo() }
        <div className={classes.layout}>
          <Paper className={classes.paper}>
            <MainComponent classes={classes} styles={styles} authHandler={this.authHandler} userInfoHandler={this.userInfoHandler} bannerHandler={this.bannerHandler} isAuthenticated={isAuthenticated} token={token} user={user}/> 
          </Paper>
        </div>
      </React.Fragment>
    );
  }
}


App.propTypes = {
  classes: PropTypes.object.isRequired,
};


export default withStyles(styles)(App);
